import { Button, Slider, Stack, Typography, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";

const useStyles = makeStyles(theme => ({
    slider: {
        zIndex: 1,
        margin: "auto",
        width: "97%",
        '& .MuiSlider-thumb': {
            width: 16,
            height: 16,
            backgroundColor: theme.palette.background.primaryAccent1,
            boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
            '&:focus, &:hover, &.Mui-active': {
                boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    // boxShadow: iOSBoxShadow,
                },
            },
            '&:before': {
                boxShadow:
                    '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
            },
        },
        '& .MuiSlider-valueLabel': {
            fontSize: 12,
            fontWeight: 'normal',
            top: -6,
            padding: "6px 16px",
            borderRadius: "12px",
            backgroundColor: theme.palette.background.primaryGrey2,
            color: theme.palette.background.primaryBlack1,
            '&::before': {
                display: 'none',
            },
            '& *': {
                background: 'transparent',
            },
        },
        '& .MuiSlider-track': {
            border: 'none',
            height: 5,
            backgroundColor: theme.palette.background.primaryAccent1,
        },
        '& .MuiSlider-rail': {
            height: 4,
            opacity: 0.5,
            boxShadow: 'inset 0px 0px 4px -2px #000',
            backgroundColor: theme.palette.background.primaryGrey3,
        }
    },
    chip: {
        padding: "4px 12px",
        background: theme.palette.background.primaryGrey2,
        borderRadius: 12
    },
    pill: {
        color: theme.palette.content.primaryBlack1,
        cursor: 'pointer',
        borderRadius: 39,
        background: theme.palette.background.primaryGrey1,
        border: `1px solid ${theme.palette.border.primaryBlack3}`,
        padding: "4px 10px",
        height: 30,
        '&:hover': {
            backgroundColor: "transparent"
        }
    },
}));

const IDEAL_NAV = "Ideal response";
const LOWEST_HIGHEST_NAV = "Lowest-highest response";

const SliderNav = ({ status, setSelected, selected }) => {
    const classes = useStyles();
    const theme = useTheme();
    return (
        <Button
            onClick={() => { setSelected(status) }}
            variant="soft"
            size="small"
            className={classes.pill}
            sx={{ border: selected === status && `1px solid ${theme.palette.border.primaryAccent1} !important`, background: selected === status && `${theme.palette.background.primaryAccent2} !important` }}
        >
            <Typography variant="caption">{status}</Typography>
        </Button>
    )
}

const Pill = ({ status, setSelected, selected, label, setFilterAPICode, FiltersMap }) => {
    const classes = useStyles();
    const theme = useTheme();
    return (
        <Button
            onClick={() => {
                setFilterAPICode(prev => {
                    const dum = { ...prev };
                    delete (dum[FiltersMap?.filter_codes[selected]]);
                    if (selected !== status) dum[FiltersMap?.filter_codes[status]] = 1;
                    console.log(dum);
                    return dum;
                })
                setSelected(prev => {
                    if (prev === status) return IDEAL_NAV;
                    return status;
                });
            }}
            variant="soft"
            size="small"
            className={classes.pill}
            sx={{ border: selected === status && `1px solid ${theme.palette.border.primaryAccent1} !important`, background: selected === status && `${theme.palette.background.primaryAccent2} !important` }}
        >
            <Typography variant="caption">{label}</Typography>
        </Button>
    )
}

const PreScreenFilter = ({ item, FiltersMap, setFilterAPICode, reset }) => {
    const classes = useStyles();

    const idealMin = parseInt(item?.response_parameters?.MIN_VALUE, 10);
    const idealMax = parseInt(item?.response_parameters?.MAX_VALUE, 10);
    const min = Math.min(...Object.keys(item?.range));
    const max = Math.max(...Object.keys(item?.range));


    const [sliderValue, setSliderValue] = useState([idealMin, idealMax]);
    const [minmax, setMinmax] = useState([idealMin, idealMax]);
    const [selected, setSelected] = useState(IDEAL_NAV);

    useEffect(() => {
        setSelected(IDEAL_NAV);
        setMinmax([idealMin, idealMax]);
        setSliderValue([idealMin, idealMax]);
    }, [idealMax, idealMin, reset]);

    // let idealCan = 0;
    // Object.keys(item?.range)?.forEach(val => {
    //     if (val > item?.response_parameters?.MIN_VALUE && val < item?.response_parameters?.MAX_VALUE) idealCan++;
    // })

    useEffect(() => {
        if (selected === IDEAL_NAV) {
            setMinmax([idealMin, idealMax]);
            setSliderValue([idealMin, idealMax]);
        }
        if (selected === LOWEST_HIGHEST_NAV) {
            setMinmax([min, max]);
            setSliderValue([min, max]);
        }
    }, [selected]);

    return (
        <Stack>
            {item?.response_type === "NUMERIC" &&
                <Stack spacing="12px" sx={{ marginBottom:"34px" }}>
                    <Typography variant="input" sx={{ fontWeight: 500 }}>{item?.text}</Typography>
                    <Stack spacing="8px" direction="row" sx={{ marginBottom: "40px" }}>
                        <SliderNav selected={selected} setSelected={setSelected} status={IDEAL_NAV} />
                        <SliderNav selected={selected} setSelected={setSelected} status={LOWEST_HIGHEST_NAV} />
                    </Stack>
                    {sliderValue && <Slider
                        value={sliderValue}
                        min={minmax?.[0]}
                        step={1}
                        max={minmax?.[1]}
                        onChange={(e, newValue) => {
                            setSliderValue(newValue);
                            const dumStr = `PRESCREENING_SCORE_${item?.text}`;
                            setFilterAPICode(prev => {
                                const dum = { ...prev };
                                dum[FiltersMap?.filter_codes[dumStr]] ={
                                    min_range:newValue[0],
                                    max_range:newValue[1]
                                }
                                console.log(dum);
                                return dum;
                            })
                        }}
                        valueLabelDisplay="on"
                        aria-labelledby="non-linear-slider"
                        className={classes.slider}
                    />}
                    {/* <Stack direction="row" justifyContent="space-between" sx={{ mt: "-14px", zIndex: 1 }}>
                        <Stack spacing="4px" alignItems="flex-start">
                            <Typography variant="caption" sx={{ marginLeft: "5px" }}>{minmax?.[0]}</Typography>
                            <Stack className={classes.chip}>
                                <Typography variant="caption">Lowest response</Typography>
                            </Stack>
                        </Stack>
                        <Stack spacing="4px" alignItems="flex-end">
                            <Typography variant="caption" sx={{ marginRight: "5px" }}>{minmax?.[1]}</Typography>
                            <Stack className={classes.chip}>
                                <Typography variant="caption">Highest response</Typography>
                            </Stack>
                        </Stack>
                    </Stack> */}
                    {/* <Stack className={classes.idealResponseDiv} sx={{ left: `${((item.response_parameters.MIN_VALUE - min) / (max - min)) * 54.3}rem`, width: `${((item.response_parameters.MAX_VALUE - item.response_parameters.MIN_VALUE) / (max - min)) * 54.2}rem` }}>
                            <Typography variant="caption" sx={{ marginTop: "18px" }}>{idealCan} Candidate{idealCan > 1 && "s"}</Typography>
                        </Stack> */}
                </Stack>
            }
            {item?.response_type === "BOOLEAN" &&
                <Stack spacing="16px">
                    <Typography variant="input" sx={{ fontWeight: 500 }}>{item?.text}</Typography>
                    <Stack spacing="8px" direction="row" sx={{ marginBottom: "0px" }}>
                        <Pill selected={selected} setSelected={setSelected} status={`PRESCREENING_QUALIFIED_${item?.text}`} label={`Yes (${item?.total_qualified})`} setFilterAPICode={setFilterAPICode} FiltersMap={FiltersMap} />
                        <Pill selected={selected} setSelected={setSelected} status={`PRESCREENING_NOT_QUALIFIED_${item?.text}`} label={`No (${item?.total_not_qualified})`} setFilterAPICode={setFilterAPICode} FiltersMap={FiltersMap} />
                    </Stack>
                    {/* <Stack spacing="8px">
                        <FormControlLabel control={<Checkbox onChange={() => { const dumstr = ; setFilterAPICode({ ...filterAPICode, [FiltersMap?.filter_codes[dumstr]]: 1 }) }} />} label={`Qualified (${item?.total_qualified})`} />
                        <FormControlLabel control={<Checkbox onChange={() => { const dumstr = `PRESCREENING_NOT_QUALIFIED_${item?.total_qualified}`; setFilterAPICode({ ...filterAPICode, [FiltersMap?.filter_codes[dumstr]]: 1 }) }} />} label={`Disqualified (${item?.total_not_qualified})`} />
                    </Stack> */}
                </Stack>
            }
        </Stack>
    )
}
export default PreScreenFilter;